import {TimelineActionTypeEnum} from '../../../../../service/timeline-activity/timeline-activity-type';

export const actionsWithSupplemented: Array<TimelineActionTypeEnum> = [
    TimelineActionTypeEnum.NewPhotos,
    TimelineActionTypeEnum.CollectReviews,
];
